import { render } from "./ScanLayout.vue?vue&type=template&id=bcefa5b8&scoped=true"
import script from "./ScanLayout.vue?vue&type=script&lang=js"
export * from "./ScanLayout.vue?vue&type=script&lang=js"

import "./ScanLayout.vue?vue&type=style&index=0&id=bcefa5b8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bcefa5b8"

export default script